import { memo } from 'react';
function MoneyOffWithOutline({ color = '#808080', size = 16 }) {  
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27 27" width={size} height={size}>
      <circle cx="13.5" cy="13.5" r="13" fill="none" stroke={color} strokeWidth={2} />
      <path
        d="M 7 8 7 9 9 11 9 12 11 14 12 14 15 17 13 19 12 18 11 18 10 17 9 17 9 18 10 19 11 19 12 20 12 21 14 21 14 20 15 19 17 19 18 20 18 19 Z"
        fill={color}
        stroke={color}
        strokeWidth={1}
      />
      <path 
        d="M 12 7 12 8 11 9 12 10 13 9 15 11 16 11 16 10 14 8 14 7 Z" 
        fill={color}
        stroke={color}
        strokeWidth={1}
      />
    </svg>
  );
}

export default memo(MoneyOffWithOutline);
